import { NFeEntradaAssociacaoItemRequest } from './nfe-entrada-associacao-item.request';

/** Salva o progresso ou conclui a associação: só os itens alterados no modal. */
export class NFeEntradaAssociacaoSalvarRequest {
  idNFeEntrada: number;
  datetimeAlteracaoNFeEntrada: Date | null;
  itens: NFeEntradaAssociacaoItemRequest[] = [];
}
